import React from "react";
import Box from "@mui/material/Box";

export default function TeamDetailChip({ label }) {
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        px: 1.5,
        py: 0.75,
        borderRadius: "20px",
        border: "1px solid #C5CED6",
        background: "#F9FAFA",
        boxShadow: "0 1px 2px 0 rgba(6, 21, 34, 0.05)",
        color: "#405261",
        fontFamily: "Inter",
        fontSize: 14,
        fontWeight: 400,
        lineHeight: "18px",
      }}
    >
      {label}
    </Box>
  );
}
